import { render, staticRenderFns } from "./component-third-link.vue?vue&type=template&id=1bc164f4&scoped=true&"
import script from "./component-third-link.vue?vue&type=script&lang=js&"
export * from "./component-third-link.vue?vue&type=script&lang=js&"
import style0 from "./component-third-link.vue?vue&type=style&index=0&id=1bc164f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc164f4",
  null
  
)

export default component.exports